export interface Ethnicity {
  ethnicity: Array<{
    code: string,
    text: string,
    value: string,
    shortName: string,
  }>
}

export function getEthnicity(): Ethnicity {
  return {
    ethnicity: [
      { code: '', text: 'ไม่ระบุ', value: 'ไม่ระบุ', shortName: '' },
      { code: '764', text: 'ไทย', value: 'ไทย', shortName: 'THA' },
      { code: '300', text: 'กรีซ', value: 'กรีซ', shortName: 'GRC' },
      { code: '116', text: 'กัมพูชา', value: 'กัมพูชา', shortName: 'KHM' },
      { code: '266', text: 'กาบอง', value: 'กาบอง', shortName: 'GAB' },
      { code: '410', text: 'เกาหลีใต้', value: 'เกาหลีใต้', shortName: 'KOR' },
      { code: '408', text: 'เกาหลีเหนือ', value: 'เกาหลีเหนือ', shortName: 'PRK' },
      { code: '188', text: 'คอสตาริกา', value: 'คอสตาริกา', shortName: 'CRI' },
      { code: '398', text: 'คาซัคสถาน', value: 'คาซัคสถาน', shortName: 'KAZ' },
      { code: '192', text: 'คิวบา', value: 'คิวบา', shortName: 'CUB' },
      { code: '417', text: 'คีร์กีซสถาน', value: 'คีร์กีซสถาน', shortName: 'KGZ' },
      { code: '414', text: 'คูเวต', value: 'คูเวต', shortName: 'KWT' },
      { code: '404', text: 'เคนยา', value: 'เคนยา', shortName: 'KEN' },
      { code: '124', text: 'แคนาดา', value: 'แคนาดา', shortName: 'CAN' },
      { code: '120', text: 'แคเมอรูน', value: 'แคเมอรูน', shortName: 'CMR' },
      { code: '191', text: 'โครเอเชีย', value: 'โครเอเชีย', shortName: 'HRV' },
      { code: '170', text: 'โคลอมเบีย', value: 'โคลอมเบีย', shortName: 'COL' },
      { code: '268', text: 'จอร์เจีย', value: 'จอร์เจีย', shortName: 'GEO' },
      { code: '400', text: 'จอร์แดน', value: 'จอร์แดน', shortName: 'JOR' },
      { code: '388', text: 'จาเมกา', value: 'จาเมกา', shortName: 'JAM' },
      { code: '156', text: 'จีน', value: 'จีน', shortName: 'CHN' },
      { code: '148', text: 'ชาด', value: 'ชาด', shortName: 'TCD' },
      { code: '152', text: 'ชิลี', value: 'ชิลี', shortName: 'CHL' },
      { code: '882', text: 'ซามัว', value: 'ซามัว', shortName: 'WSM' },
      { code: '716', text: 'ซิมบับเว', value: 'ซิมบับเว', shortName: 'ZWE' },
      { code: '760', text: 'ซีเรีย', value: 'ซีเรีย', shortName: 'SYR' },
      { code: '736', text: 'ซูดาน', value: 'ซูดาน', shortName: 'SDN' },
      { code: '740', text: 'ซูรินาม', value: 'ซูรินาม', shortName: 'SUR' },
      { code: '690', text: 'เซเชลส์', value: 'เซเชลส์', shortName: 'SYC' },
      { code: '662', text: 'เซนต์ลูเชีย', value: 'เซนต์ลูเชีย', shortName: 'LCA' },
      { code: '686', text: 'เซเนกัล', value: 'เซเนกัล', shortName: 'SEN' },
      { code: '706', text: 'โซมาเลีย', value: 'โซมาเลีย', shortName: 'SOM' },
      { code: '392', text: 'ญี่ปุ่น', value: 'ญี่ปุ่น', shortName: 'JPN' },
      { code: '776', text: 'ตองงา', value: 'ตองงา', shortName: 'TON' },
      { code: '792', text: 'ตุรกี', value: 'ตุรกี', shortName: 'TUR' },
      { code: '788', text: 'ตูนิเซีย', value: 'ตูนิเซีย', shortName: 'TUN' },
      { code: '768', text: 'โตโก', value: 'โตโก', shortName: 'TGO' },
      { code: '158', text: 'ไต้หวัน', value: 'ไต้หวัน', shortName: 'TWN' },
      { code: '834', text: 'แทนซาเนีย', value: 'แทนซาเนีย', shortName: 'TZA' },
      { code: '578', text: 'นอร์เวย์', value: 'นอร์เวย์', shortName: 'NOR' },
      { code: '520', text: 'นาอูรู', value: 'นาอูรู', shortName: 'NRU' },
      { code: '558', text: 'นิการากัว', value: 'นิการากัว', shortName: 'NIC' },
      { code: '554', text: 'นิวซีแลนด์', value: 'นิวซีแลนด์', shortName: 'NZL' },
      { code: '528', text: 'เนเธอร์แลนด์', value: 'เนเธอร์แลนด์', shortName: 'NLD' },
      { code: '524', text: 'เนปาล', value: 'เนปาล', shortName: 'NPL' },
      { code: '566', text: 'ไนจีเรีย', value: 'ไนจีเรีย', shortName: 'NGA' },
      { code: '562', text: 'ไนเจอร์', value: 'ไนเจอร์', shortName: 'NER' },
      { code: '76', text: 'บราซิล', value: 'บราซิล', shortName: 'BRA' },
      { code: '96', text: 'บรูไน', value: 'บรูไน', shortName: 'BRN' },
      { code: '50', text: 'บังกลาเทศ', value: 'บังกลาเทศ', shortName: 'BGD' },
      { code: '100', text: 'บัลแกเรีย', value: 'บัลแกเรีย', shortName: 'BGR' },
      { code: '52', text: 'บาร์เบโดส', value: 'บาร์เบโดส', shortName: 'BRB' },
      { code: '48', text: 'บาห์เรน', value: 'บาห์เรน', shortName: 'BHR' },
      { code: '44', text: 'บาฮามาส', value: 'บาฮามาส', shortName: 'BHS' },
      { code: '108', text: 'บุรุนดี', value: 'บุรุนดี', shortName: 'BDI' },
      { code: '56', text: 'เบลเยียม', value: 'เบลเยียม', shortName: 'BEL' },
      { code: '112', text: 'เบลารุส', value: 'เบลารุส', shortName: 'BLR' },
      { code: '68', text: 'โบลิเวีย', value: 'โบลิเวีย', shortName: 'BOL' },
      { code: '586', text: 'ปากีสถาน', value: 'ปากีสถาน', shortName: 'PAK' },
      { code: '591', text: 'ปานามา', value: 'ปานามา', shortName: 'PAN' },
      { code: '600', text: 'ปารากวัย', value: 'ปารากวัย', shortName: 'PRY' },
      { code: '604', text: 'เปรู', value: 'เปรู', shortName: 'PER' },
      { code: '620', text: 'โปรตุเกส', value: 'โปรตุเกส', shortName: 'PRT' },
      { code: '616', text: 'โปแลนด์', value: 'โปแลนด์', shortName: 'POL' },
      { code: '250', text: 'ฝรั่งเศส', value: 'ฝรั่งเศส', shortName: 'FRA' },
      { code: '104', text: 'พม่า', value: 'พม่า', shortName: 'MMR' },
      { code: '246', text: 'ฟินแลนด์', value: 'ฟินแลนด์', shortName: 'FIN' },
      { code: '608', text: 'ฟิลิปปินส์', value: 'ฟิลิปปินส์', shortName: 'PHL' },
      { code: '242', text: 'ฟีจี', value: 'ฟีจี', shortName: 'FJI' },
      { code: '64', text: 'ภูฏาน', value: 'ภูฏาน', shortName: 'BTN' },
      { code: '496', text: 'มองโกเลีย', value: 'มองโกเลีย', shortName: 'MNG' },
      { code: '480', text: 'มอริเชียส', value: 'มอริเชียส', shortName: 'MUS' },
      { code: '478', text: 'มอริเตเนีย', value: 'มอริเตเนีย', shortName: 'MRT' },
      { code: '470', text: 'มอลตา', value: 'มอลตา', shortName: 'MLT' },
      { code: '450', text: 'มาดากัสการ์', value: 'มาดากัสการ์', shortName: 'MDG' },
      { code: '466', text: 'มาลี', value: 'มาลี', shortName: 'MLI' },
      { code: '458', text: 'มาเลเซีย', value: 'มาเลเซีย', shortName: 'MYS' },
      { code: '484', text: 'เม็กซิโก', value: 'เม็กซิโก', shortName: 'MEX' },
      { code: '508', text: 'โมซัมบิก', value: 'โมซัมบิก', shortName: 'MOZ' },
      { code: '492', text: 'โมนาโก', value: 'โมนาโก', shortName: 'MCO' },
      { code: '504', text: 'โมร็อกโก', value: 'โมร็อกโก', shortName: 'MAR' },
      { code: '887', text: 'เยเมน', value: 'เยเมน', shortName: 'YEM' },
      { code: '276', text: 'เยอรมนี', value: 'เยอรมนี', shortName: 'DEU' },
      { code: '643', text: 'รัสเซีย', value: 'รัสเซีย', shortName: 'RUS' },
      { code: '642', text: 'โรมาเนีย', value: 'โรมาเนีย', shortName: 'ROU' },
      { code: '442', text: 'ลักเซมเบิร์ก', value: 'ลักเซมเบิร์ก', shortName: 'LUX' },
      { code: '428', text: 'ลัตเวีย', value: 'ลัตเวีย', shortName: 'LVA' },
      { code: '418', text: 'ลาว', value: 'ลาว', shortName: 'LAO' },
      { code: '434', text: 'ลิเบีย', value: 'ลิเบีย', shortName: 'LBY' },
      { code: '422', text: 'เลบานอน', value: 'เลบานอน', shortName: 'LBN' },
      { code: '430', text: 'ไลบีเรีย', value: 'ไลบีเรีย', shortName: 'LBR' },
      { code: '548', text: 'วานูวาตู', value: 'วานูวาตู', shortName: 'VUT' },
      { code: '862', text: 'เวเนซุเอลา', value: 'เวเนซุเอลา', shortName: 'VEN' },
      { code: '704', text: 'เวียดนาม', value: 'เวียดนาม', shortName: 'VNM' },
      { code: '144', text: 'ศรีลังกา', value: 'ศรีลังกา', shortName: 'LKA' },
      { code: '724', text: 'สเปน', value: 'สเปน', shortName: 'ESP' },
      { code: '756', text: 'สวิตเซอร์แลนด์', value: 'สวิตเซอร์แลนด์', shortName: 'CHE' },
      { code: '840', text: 'สหรัฐ', value: 'สหรัฐ', shortName: 'USA' },
      { code: '784', text: 'สหรัฐอาหรับเอมิเรตส์', value: 'สหรัฐอาหรับเอมิเรตส์', shortName: 'ARE' },
      { code: '702', text: 'สิงคโปร์', value: 'สิงคโปร์', shortName: 'SGP' },
      { code: '36', text: 'ออสเตรเลีย', value: 'ออสเตรเลีย', shortName: 'AUS' },
      { code: '40', text: 'ออสเตรีย', value: 'ออสเตรีย', shortName: 'AUT' },
      { code: '20', text: 'อันดอร์รา', value: 'อันดอร์รา', shortName: 'AND' },
      { code: '4', text: 'อัฟกานิสถาน', value: 'อัฟกานิสถาน', shortName: 'AFG' },
      { code: '32', text: 'อาร์เจนตินา', value: 'อาร์เจนตินา', shortName: 'ARG' },
      { code: '51', text: 'อาร์มีเนีย', value: 'อาร์มีเนีย', shortName: 'ARM' },
      { code: '360', text: 'อินโดนีเซีย', value: 'อินโดนีเซีย', shortName: 'IDN' },
      { code: '368', text: 'อิรัก', value: 'อิรัก', shortName: 'IRQ' },
      { code: '376', text: 'อิสราเอล', value: 'อิสราเอล', shortName: 'ISR' },
      { code: '858', text: 'อุรุกวัย', value: 'อุรุกวัย', shortName: 'URY' },
      { code: '218', text: 'เอกวาดอร์', value: 'เอกวาดอร์', shortName: 'ECU' },
      { code: '231', text: 'เอธิโอเปีย', value: 'เอธิโอเปีย', shortName: 'ETH' },
      { code: '232', text: 'เอริเทรีย', value: 'เอริเทรีย', shortName: 'ERI' },
      { code: '222', text: 'เอลซัลวาดอร์', value: 'เอลซัลวาดอร์', shortName: 'SLV' },
      { code: '233', text: 'เอสโตเนีย', value: 'เอสโตเนีย', shortName: 'EST' },
      { code: '710', text: 'แอฟริกาใต้', value: 'แอฟริกาใต้', shortName: 'ZAF' },
      { code: '12', text: 'แอลจีเรีย', value: 'แอลจีเรีย', shortName: 'DZA' },
      { code: '8', text: 'แอลเบเนีย', value: 'แอลเบเนีย', shortName: 'ALB' },
      { code: '512', text: 'โอมาน', value: 'โอมาน', shortName: 'OMN' },
      { code: '372', text: 'ไอร์แลนด์', value: 'ไอร์แลนด์', shortName: 'IRL' },
      { code: '340', text: 'ฮอนดูรัส', value: 'ฮอนดูรัส', shortName: 'HND' },
      { code: '348', text: 'ฮังการี', value: 'ฮังการี', shortName: 'HUN' },
      { code: '535', text: 'เนเธอร์แลนด์แคริบเบียน', value: 'เนเธอร์แลนด์แคริบเบียน', shortName: 'BES' },
    ],
  }
}
